"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderUtils = void 0;
const TradeAPILib_1 = require("TradeAPILib");
const OrderGroupUtils_1 = require("./OrderGroupUtils");
const interface_1 = require("../interface");
const withoutExchangeInfoOrderType = [TradeAPILib_1.ExchangeOrderType.market, TradeAPILib_1.ExchangeOrderType.limit];
function parseMultiCoinOrderToSymbolList(coins, symbolListResult, quote, exchange) {
    coins.forEach((item1) => {
        if (!symbolListResult.some((v) => v.base === item1.base && v.quote === quote && v.market === exchange)) {
            symbolListResult.push({
                base: item1.base,
                quote: quote,
                market: exchange !== null && exchange !== void 0 ? exchange : "",
            });
        }
    });
}
exports.OrderUtils = {
    /**
     * 获取运行中订单列表中的所有交易对
     */
    getAllSymbolsFromRunningOrderList: ({ orderList, exchange, extraSymbolList, }) => {
        const symbolListResult = [];
        orderList.forEach((item) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11;
            if (withoutExchangeInfoOrderType.some((a) => a === item.orderType)) {
                if (!symbolListResult.some((v) => v.base === item.base && v.quote === item.quote && v.market === exchange)) {
                    symbolListResult.push({
                        base: item.base,
                        quote: item.quote,
                        market: exchange,
                    });
                }
            }
            else if (item.orderType === TradeAPILib_1.ExchangeOrderType.SR) {
                parseMultiCoinOrderToSymbolList(((_b = (_a = item.exchangeSROrder) === null || _a === void 0 ? void 0 : _a.coins.filter((a) => a.base !== item.quote && a.currentBaseAmount !== 0)) !== null && _b !== void 0 ? _b : []).map((v) => {
                    return { base: v.base };
                }), symbolListResult, item.quote, item.exchange);
            }
            else if (item.orderType === TradeAPILib_1.ExchangeOrderType.martingale) {
                parseMultiCoinOrderToSymbolList(((_d = (_c = item.exchangeMTGOrder) === null || _c === void 0 ? void 0 : _c.coins) !== null && _d !== void 0 ? _d : []).map((v) => {
                    return { base: v.base };
                }), symbolListResult, item.quote, item.exchange);
            }
            else if (item.orderType === TradeAPILib_1.ExchangeOrderType.futures_martingale) {
                parseMultiCoinOrderToSymbolList(((_f = (_e = item.exchangeMTGFuturesOrder) === null || _e === void 0 ? void 0 : _e.portfolio) !== null && _f !== void 0 ? _f : []).map((v) => {
                    return { base: v.base };
                }), symbolListResult, item.quote, item.exchange);
            }
            else if (item.orderType === TradeAPILib_1.ExchangeOrderType.SC) {
                parseMultiCoinOrderToSymbolList(((_h = (_g = item.exchangeSCOrder) === null || _g === void 0 ? void 0 : _g.coins) !== null && _h !== void 0 ? _h : []).map((v) => {
                    return { base: v.trade_base || v.base };
                }), symbolListResult, item.quote, item.exchange);
            }
            else if (item.orderType === TradeAPILib_1.ExchangeOrderType.enhanced_aip) {
                parseMultiCoinOrderToSymbolList(((_k = (_j = item.exchangeEnhancedAipOrder) === null || _j === void 0 ? void 0 : _j.coins) !== null && _k !== void 0 ? _k : []).map((v) => {
                    return { base: v.base };
                }), symbolListResult, item.quote, item.exchange);
            }
            else if (item.orderType === TradeAPILib_1.ExchangeOrderType.futures_smart_trade) {
                parseMultiCoinOrderToSymbolList(((_m = (_l = item.exchangeFSTOrder) === null || _l === void 0 ? void 0 : _l.portfolio) !== null && _m !== void 0 ? _m : []).map((v) => {
                    return { base: v.base };
                }), symbolListResult, item.quote, item.exchange);
            }
            else if (item.orderType === TradeAPILib_1.ExchangeOrderType.order_group) {
                symbolListResult.push(...OrderGroupUtils_1.OrderGroupUtils.getOrderGroupSymbol(item));
            }
            else if (item.orderType === TradeAPILib_1.ExchangeOrderType.copy_bot) {
                if ((_o = item.exchangeCopyBotOrder) === null || _o === void 0 ? void 0 : _o.group_info) {
                    symbolListResult.push(...OrderGroupUtils_1.OrderGroupUtils.getOrderSymbolImp((_p = item.exchangeCopyBotOrder) === null || _p === void 0 ? void 0 : _p.group_info, (_q = item.exchange) !== null && _q !== void 0 ? _q : ""));
                }
                if (extraSymbolList) {
                    extraSymbolList.forEach((obj) => {
                        if (!symbolListResult.some((v) => v.base === obj.base && v.quote === obj.quote && v.market === obj.market)) {
                            symbolListResult.push(obj);
                        }
                    });
                }
            }
            else {
                if (!symbolListResult.some((v) => v.base === item.base && v.quote === item.quote && v.market === item.exchange)) {
                    symbolListResult.push({
                        base: item.base,
                        quote: item.quote,
                        market: (_r = item.exchange) !== null && _r !== void 0 ? _r : "",
                    });
                }
            }
            if ([TradeAPILib_1.ExchangeOrderType.gridV4, TradeAPILib_1.ExchangeOrderType.gridV5].includes(item.orderType) && !interface_1.StableCoin.includes(item.quote)) {
                if (!symbolListResult.some((v) => v.base === item.base && v.quote === "USDT" && v.market === item.exchange)) {
                    symbolListResult.push({
                        base: item.base,
                        quote: "USDT",
                        market: (_s = item.exchange) !== null && _s !== void 0 ? _s : "",
                    });
                }
                if (!symbolListResult.some((v) => v.base === item.quote && v.quote === "USDT" && v.market === item.exchange)) {
                    symbolListResult.push({
                        base: item.quote,
                        quote: "USDT",
                        market: (_t = item.exchange) !== null && _t !== void 0 ? _t : "",
                    });
                }
            }
            if (item.orderType === TradeAPILib_1.ExchangeOrderType.fsa) {
                if (!symbolListResult.some((v) => {
                    var _a, _b, _c;
                    return v.base === ((_a = item.exchangeFSAOrder) === null || _a === void 0 ? void 0 : _a.swapBase) &&
                        v.quote === ((_b = item.exchangeFSAOrder) === null || _b === void 0 ? void 0 : _b.swapQuote) &&
                        v.market === ((_c = item.exchangeFSAOrder) === null || _c === void 0 ? void 0 : _c.swapExchange);
                })) {
                    symbolListResult.push({
                        base: (_v = (_u = item.exchangeFSAOrder) === null || _u === void 0 ? void 0 : _u.swapBase) !== null && _v !== void 0 ? _v : "",
                        quote: (_x = (_w = item.exchangeFSAOrder) === null || _w === void 0 ? void 0 : _w.swapQuote) !== null && _x !== void 0 ? _x : "",
                        market: (_z = (_y = item.exchangeFSAOrder) === null || _y === void 0 ? void 0 : _y.swapExchange) !== null && _z !== void 0 ? _z : "",
                    });
                }
            }
            if (item.orderType === TradeAPILib_1.ExchangeOrderType.cm_fsa) {
                if (!symbolListResult.some((v) => {
                    var _a, _b, _c;
                    return v.base === ((_a = item.exchangeCMFSAOrder) === null || _a === void 0 ? void 0 : _a.swapBase) &&
                        v.quote === ((_b = item.exchangeCMFSAOrder) === null || _b === void 0 ? void 0 : _b.swapQuote) &&
                        v.market === ((_c = item.exchangeCMFSAOrder) === null || _c === void 0 ? void 0 : _c.swapExchange);
                })) {
                    symbolListResult.push({
                        base: (_1 = (_0 = item.exchangeCMFSAOrder) === null || _0 === void 0 ? void 0 : _0.swapBase) !== null && _1 !== void 0 ? _1 : "",
                        quote: (_3 = (_2 = item.exchangeCMFSAOrder) === null || _2 === void 0 ? void 0 : _2.swapQuote) !== null && _3 !== void 0 ? _3 : "",
                        market: (_5 = (_4 = item.exchangeCMFSAOrder) === null || _4 === void 0 ? void 0 : _4.swapExchange) !== null && _5 !== void 0 ? _5 : "",
                    });
                }
            }
            if (item.orderType === TradeAPILib_1.ExchangeOrderType.reverse_fsa) {
                if (!symbolListResult.some((v) => {
                    var _a, _b, _c;
                    return v.base === ((_a = item.exchangeReverseFSAOrder) === null || _a === void 0 ? void 0 : _a.swapBase) &&
                        v.quote === ((_b = item.exchangeReverseFSAOrder) === null || _b === void 0 ? void 0 : _b.swapQuote) &&
                        v.market === ((_c = item.exchangeReverseFSAOrder) === null || _c === void 0 ? void 0 : _c.swapExchange);
                })) {
                    symbolListResult.push({
                        base: (_7 = (_6 = item.exchangeReverseFSAOrder) === null || _6 === void 0 ? void 0 : _6.swapBase) !== null && _7 !== void 0 ? _7 : "",
                        quote: (_9 = (_8 = item.exchangeReverseFSAOrder) === null || _8 === void 0 ? void 0 : _8.swapQuote) !== null && _9 !== void 0 ? _9 : "",
                        market: (_11 = (_10 = item.exchangeReverseFSAOrder) === null || _10 === void 0 ? void 0 : _10.swapExchange) !== null && _11 !== void 0 ? _11 : "",
                    });
                }
            }
        });
        return symbolListResult.filter((v) => v.base !== v.quote);
    },
    /**
     * 获取历史订单列表中的所有交易对
     */
    getAllSymbolsFromHistoryOrderList: ({ orderList, }) => {
        const symbolListResult = [];
        orderList.forEach((item) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            switch (item.orderType) {
                case TradeAPILib_1.ExchangeOrderType.SR: {
                    parseMultiCoinOrderToSymbolList(((_b = (_a = item.exchangeSROrder) === null || _a === void 0 ? void 0 : _a.coins.filter((a) => a.base !== item.quote && a.currentBaseAmount !== 0)) !== null && _b !== void 0 ? _b : []).map((v) => {
                        return { base: v.base };
                    }), symbolListResult, item.quote, item.exchange);
                    break;
                }
                case TradeAPILib_1.ExchangeOrderType.martingale: {
                    parseMultiCoinOrderToSymbolList(((_d = (_c = item.exchangeMTGOrder) === null || _c === void 0 ? void 0 : _c.coins) !== null && _d !== void 0 ? _d : []).map((v) => {
                        return { base: v.base };
                    }), symbolListResult, item.quote, item.exchange);
                    break;
                }
                case TradeAPILib_1.ExchangeOrderType.futures_martingale: {
                    parseMultiCoinOrderToSymbolList(((_f = (_e = item.exchangeMTGFuturesOrder) === null || _e === void 0 ? void 0 : _e.portfolio) !== null && _f !== void 0 ? _f : []).map((v) => {
                        return { base: v.base };
                    }), symbolListResult, item.quote, item.exchange);
                    break;
                }
                case TradeAPILib_1.ExchangeOrderType.SC: {
                    parseMultiCoinOrderToSymbolList(((_h = (_g = item.exchangeSCOrder) === null || _g === void 0 ? void 0 : _g.coins) !== null && _h !== void 0 ? _h : []).map((v) => {
                        return { base: v.base };
                    }), symbolListResult, item.quote, item.exchange);
                    break;
                }
                case TradeAPILib_1.ExchangeOrderType.enhanced_aip: {
                    parseMultiCoinOrderToSymbolList(((_k = (_j = item.exchangeEnhancedAipOrder) === null || _j === void 0 ? void 0 : _j.coins) !== null && _k !== void 0 ? _k : []).map((v) => {
                        return { base: v.base };
                    }), symbolListResult, item.quote, item.exchange);
                    break;
                }
                default: {
                    if (!symbolListResult.some((v) => v.base === item.base && v.quote === item.quote && v.market === item.exchange)) {
                        symbolListResult.push({
                            base: item.base,
                            quote: item.quote,
                            market: (_l = item.exchange) !== null && _l !== void 0 ? _l : "",
                        });
                    }
                }
            }
        });
        return symbolListResult;
    },
};
